// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2aaoJ","alertIcon":"ConfirmModal_alertIcon__3YkB1"};